import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {getFetcher} from "../utils/fetcher";
import {GET_NICE_USER_INFO_API, POST_NICE_USER_INFO_API} from "../constants/api_constants";
import {toast} from "react-toastify";
import {MAIN_PAGE_TEMP, SIGNUP_PAGE} from "../constants/page_constants";
import {accountInfo, USER_INFO} from "../constants/constants";
import neverLandUtils from "../utils/NeverLandUtils";

const NiceCallbackPage = () => {
  const navigate = useNavigate();
  // 기존 고객은 메인으로, 신규 고객은 회원가입으로 분기 타기
  const link = accountInfo.isLogin() ? MAIN_PAGE_TEMP : SIGNUP_PAGE;
  const params = new URLSearchParams(window.location.search);
  const result = params.get('result');
  const tokenId = params.get('tokenId');

  useEffect(() => {
    if (result === 'success' && tokenId) {
      console.log('✅ 인증 성공! tokenId:', tokenId);
      // 인증 성공 시 백엔드에 토큰 보내서 유저 정보 받아오기
      (async () => {
        try {
          const res = await getFetcher().post(GET_NICE_USER_INFO_API, {tokenId});
          const header = res.data.header;
          const userInfo = res.data.result.data;
          let niceAuthData;

          if (header.type === 'success') {
            // <- 인증 성공 ->
            if (!accountInfo.isLogin()) {
              // 신규회원은 로컬스토리지에 저장
              niceAuthData = {
                  niceUserInfo: userInfo,
                  tokenId: tokenId,
                  isCertify: true,
              };
            } else {
              // 기존 회원은 백엔드에 토큰정보 바로 보내기
              sendNiceTokenAndEmail();
            }
          } else if (header.type === 'fail') {
            // <- 인증 실패 : 실패사유 로컬 저장 ->
            niceAuthData = {
              isCertify: false,
              message: header.message,
            };
          }
          // 페이지 이동 및 로컬 저장
          localStorage.setItem('nice_auth', JSON.stringify(niceAuthData));
          window.parent.location.href = link;
        } catch (err) {
          console.log('인증 정보 요청 실패', err);
          window.parent.location.href = link;
        }
      })();
    } else {
      toast.error('본인인증에 실패했습니다.');
      window.parent.location.href = link;
    }
  }, [navigate]);

  const sendNiceTokenAndEmail = () => {
    // 백엔드에 토큰 정보 넘겨주기
    getFetcher().post(POST_NICE_USER_INFO_API, {
      tokenId: tokenId,
      email: neverLandUtils.commons.load(USER_INFO)?.email,
    }).then(res => {
      const {type, message} = res.data.header;
      if (type === 'success') {

      } else {
        toast.warn(message);
      }
    }).catch((err) => {
      console.log('토큰전달 실패', err);
    })
  }

  return (
      <>
        <div>인증 처리 중입니다...</div>
      </>
  );
};

export default NiceCallbackPage;